import { createContext } from "react";
import { FlashType } from "./interfaces";

const FlashMessageContext = createContext({
  setFlash: (_: FlashType) => {},
});

export default FlashMessageContext;
